// `/inbox` route — Wave 5c.1 entry.

import { createRoute } from '@tanstack/react-router';

import { InboxPage } from '@/features/inbox/InboxPage';

import { Route as InboxLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => InboxLayoutRoute,
  path: '/',
  component: InboxIndex,
});

function InboxIndex() {
  return <InboxPage />;
}
